import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  public readonly title = 'PacPro';

  private readonly _translate = inject(TranslateService);

  constructor() {
    this._translate.addLangs(['pt-BR', 'en']);
    this._translate.setFallbackLang('pt-BR');
    this._translate.use('pt-BR');
  }
}
